import { useState, useEffect, useCallback, useRef } from "react";
import { socialApi } from "../services/socialApi";

const REFRESH_MS = 5 * 60 * 1000;

export function useSocial() {
  const [data, setData]         = useState(null);
  const [realtime, setRealtime] = useState(null);
  const [loading, setLoading]   = useState(true);
  const [error, setError]       = useState(null);
  const [lastUpdated, setLastUpdated] = useState(null);
  const mountedRef = useRef(true);

  useEffect(() => {
    mountedRef.current = true;
    return () => { mountedRef.current = false; };
  }, []);

  const fetchOverview = useCallback(async () => {
    try {
      const overview = await socialApi.overview();
      if (!mountedRef.current) return;
      setData(overview);
      setLastUpdated(new Date());
      setError(null);
    } catch (err) {
      if (mountedRef.current) setError(err.message);
    } finally {
      if (mountedRef.current) setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchOverview();
    const t = setInterval(fetchOverview, REFRESH_MS);
    return () => clearInterval(t);
  }, [fetchOverview]);

  // Socket.IO — subscribe to server-pushed social events
  useEffect(() => {
    let socket = null;
    try {
      // eslint-disable-next-line
      const { io } = require("socket.io-client");
      const SOCKET_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";
      socket = io(SOCKET_URL, { reconnectionAttempts: 3, reconnectionDelay: 2000, timeout: 3000 });
      socket.on("socialRealtime", (rt) => {
        if (mountedRef.current) setRealtime(rt);
      });
      socket.on("socialStats", () => {
        if (mountedRef.current) fetchOverview();
      });
    } catch (e) {}
    return () => { if (socket) socket.disconnect(); };
  }, [fetchOverview]);

  return { data, realtime, loading, error, lastUpdated, refresh: fetchOverview };
}
